import { Component, Input } from '@angular/core';
import { MatIcon } from "@angular/material/icon";

export type StepperState = "disabled" | "available" | "warn" | "checked";

export interface StepperData {
  step: string,
  title: string,
  completed: boolean,
  state: StepperState,
  isSelected?: boolean,
  isDisabled?: boolean,
  disabledIcon?: string,
  availableIcon?: string,
  warnIcon?: string,
  checkedIcon?: string,
}

@Component({
  selector: 'msh-stepper',
  imports: [MatIcon],
  template: `
    @if(step){
      <div [class]="'flex items-center gap-2 border rounded-md p-2 pr-4 ' 
          + (step.isSelected ? 'border-orange-500 ' : ' border-copy/15 ') 
          + (step.isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer bg-copy/10 hover:bg-copy/30')
      ">
        <div [class]="'w-10 h-10 scale-75 rounded-full flex items-center justify-center text-xs shrink-0 ' + (step.state === 'disabled' || step.isDisabled ? 'bg-copy/50 text-back' : step.state === 'available' ? 'bg-orange-400 text-white' : step.state === 'warn' ? 'bg-red-500 border-red-500 text-white' : step.state === 'checked' ? 'bg-green-500 text-white' : '')">
          @if(step.state === 'disabled'){
            <mat-icon class="">{{step.disabledIcon ? step.disabledIcon : default.disabledIcon}}</mat-icon>
          } @else if(step.state === 'available'){
            <mat-icon>{{step.availableIcon ? step.availableIcon : default.availableIcon}}</mat-icon>
          } @else if(step.state === 'warn'){
            <mat-icon>{{step.warnIcon ? step.warnIcon : default.warnIcon}}</mat-icon>
          } @else if(step.state === 'checked'){
            <mat-icon>{{step.checkedIcon ? step.checkedIcon : default.checkedIcon}}</mat-icon>
          } @else {
            {{step.completed ? '✓' : ''}}
          }
        </div>
        <div [class]="' ' + (step.state === 'disabled' || step.isDisabled ? 'text-copy/50' : 'text-copy')">{{step.title}}</div>
      </div>
      @if(!isLast){
        <div class="w-6 h-0.5 bg-copy/50 -mt-1.5 mx-auto"></div>
      }
    }
  `,
  styles: `
  :host { display: flex; align-items: center;}`
})
export class StepperComponent {
  @Input() step: StepperData | null = null;
  @Input() isLast = false;
  default = {
    disabledIcon: 'close',
    availableIcon: 'edit',
    warnIcon: 'warning',
    checkedIcon: 'check',
  }
}
